import { Search as SearchIcon } from "@mui/icons-material";
import { InputAdornment, TextField } from "@mui/material";

interface Props {
	value: string;
	onChange: (text: string) => void;
	label: string;
}

export const SearchTextField = ({ value, onChange, label }: Props) => {
	return (
		<TextField
			fullWidth
			variant="outlined"
			placeholder={label}
			value={value}
			onChange={(e) => onChange(e.target.value)}
			size="small"
			InputProps={{
				startAdornment: (
					<InputAdornment position="start">
						<SearchIcon />
					</InputAdornment>
				),
			}}
		/>
	);
};
